import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceItaComponent } from './service-ita.component';
import { ServiceItaRouter } from './service-ita.routing';
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  imports: [
    CommonModule,
    ServiceItaRouter,
    TranslateModule,
    NgbModule
  ],
  declarations: [ServiceItaComponent]
})
export class ServiceItaModule { }
